import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import Carousel from 'react-multi-carousel';
import { useStore, } from '@mcn-platform/models';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import LessonCard from './card/LessonCard';
import PlaceHolder from '../common/PlaceHolder';
import { configureSalesCard } from '../common/portalConfig';
import WysiwygTitle from './WysiwygTitle';
const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1536 },
        items: 4,
    },
    largeDesktop: {
        breakpoint: { max: 1536, min: 1200 },
        items: 4,
    },
    desktop: {
        breakpoint: { max: 1200, min: 900 },
        items: 4,
    },
    tablet: {
        breakpoint: { max: 900, min: 600 },
        items: 3,
    },
    mobile: {
        breakpoint: { max: 600, min: 0 },
        items: 1,
    },
};
const LessonCarousel = ({ courseID, editData, configId, content, limitToPageWidth, settings: { showTitle, maxItemCount, padding, }, backgroundColor, disabled = false, }) => {
    const store = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    const isEmpty = !courseID && !content.slate;
    if (isEmpty && editData && editData.activeConfigId !== configId) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Lesson Carousel" }));
    }
    // if (!courseID) {
    //   return null;
    // }
    const course = store.getOrLoad('course', courseID);
    // if (course.syncState !== 'loaded') {
    //   return null;
    // }
    // if (!store.currentPortal) {
    //   return null;
    // }
    const { action, } = configureSalesCard(store.currentPortal, course, undefined, navigate, location, '.');
    const courseSections = course.filterSections('video');
    return (_jsxs(Box, { sx: {
            backgroundColor: { backgroundColor },
            p: (`${padding}px`),
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: [_jsx(WysiwygTitle, { showTitle: showTitle, editData: editData, content: content, configId: configId, disabled: disabled }), courseSections.length > 0 && (_jsx(Carousel
            // className={classes.carouselRoot}
            , { 
                // className={classes.carouselRoot}
                responsive: responsive, children: courseSections.slice(0, maxItemCount).map((section) => (section.item && (_jsx(Box, { sx: {
                        margin: '4px',
                    }, children: _jsx(LessonCard, { size: "large", section: section, action: action }) }, section.id)))) }))] }));
};
LessonCarousel.defaultProps = {
    content: {
        slate: undefined,
        html: '<div>Title</div>',
    },
    courseID: undefined,
    settings: {
        showTitle: true,
        maxItemCount: 20,
    },
    disabled: false,
};
LessonCarousel.meta = {
    group: 'display',
    name: 'Lesson Carousel',
    description: 'Displays lessons from a course in a carousel.',
    props: [
        {
            key: 'courseID',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'Course from which lessons will be displayed',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show the title of items',
        },
        {
            key: 'content',
            name: 'Title',
            type: 'richtext', // note this is a special type recognized by the system
            description: 'Title of carousel',
            inPlaceEdit: true,
        },
        {
            key: 'settings.maxItemCount',
            name: 'Maximum Number of Items',
            type: 'number',
            description: 'Maximum number of items to appear in carousel.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'LessonCarousel',
        props: {
            limitToPageWidth: true,
            content: {
                slate: undefined,
                html: '<div>&nbsp;</div>',
            },
            settings: {
                showTitle: true,
                itemsCount: 10,
            },
        },
    },
};
LessonCarousel.IpeWrapper = WysiwygTitle.IpeWrapper;
LessonCarousel.ipeControls = WysiwygTitle.ipeControls;
export default observer(LessonCarousel);
//# sourceMappingURL=LessonCarousel.js.map